import { useState, useEffect } from "react";
import { TESTIMONIALS } from "../data/siteData";

export default function TestimonialSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % TESTIMONIALS.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [isPaused]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? TESTIMONIALS.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % TESTIMONIALS.length);
  };

  return (
    <section className="py-20 bg-[#18181b] text-white overflow-hidden relative border-y border-[#27272a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div className="space-y-3 max-w-2xl">
            <span className="text-[#d96b27] font-bold text-xs uppercase tracking-widest bg-[#27272a] px-3.5 py-1 rounded-full inline-block border border-[#3f3f46]">
              Kundetilfredshed & Anmeldelser
            </span>
            <h2 className="text-3xl sm:text-4xl font-extrabold uppercase tracking-tight">
              Det siger vores tilfredse kunder
            </h2>
            <p className="text-gray-400 text-base">
              Høj tilfredshed og glade bygherrer er grundstenen i vores tømrerforretning.
            </p>
          </div>

          {/* Navigation Controls */}
          <div className="flex items-center gap-3">
            <button
              onClick={handlePrev}
              className="w-12 h-12 rounded-md bg-[#27272a] hover:bg-[#d96b27] text-gray-200 hover:text-white border border-[#3f3f46] flex items-center justify-center transition-all focus:outline-none focus:ring-2 focus:ring-[#d96b27]"
              aria-label="Forrige anmeldelse"
            >
              <i className="fa-solid fa-arrow-left text-base" aria-hidden="true" />
            </button>
            <button
              onClick={handleNext}
              className="w-12 h-12 rounded-md bg-[#27272a] hover:bg-[#d96b27] text-gray-200 hover:text-white border border-[#3f3f46] flex items-center justify-center transition-all focus:outline-none focus:ring-2 focus:ring-[#d96b27]"
              aria-label="Næste anmeldelse"
            >
              <i className="fa-solid fa-arrow-right text-base" aria-hidden="true" />
            </button>
          </div>
        </div>

        {/* Testimonials Slider Grid (Showing 3 on Desktop, 2 on Tablet, 1 on Mobile) */}
        <div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          {[0, 1, 2].map((offset) => {
            const index = (currentIndex + offset) % TESTIMONIALS.length;
            const review = TESTIMONIALS[index];
            return (
              <div
                key={`${review.id}-${offset}`}
                className={`bg-[#27272a] border border-[#3f3f46] p-7 rounded-lg shadow-lg flex flex-col justify-between transition-all duration-500 ${
                  offset === 1 ? "hidden md:flex" : ""
                } ${offset === 2 ? "hidden lg:flex" : ""}`}
              >
                <div className="space-y-4">
                  {/* Rating Stars */}
                  <div className="flex items-center gap-1 text-[#d96b27]">
                    {[...Array(review.rating)].map((_, i) => (
                      <i key={i} className="fa-solid fa-star text-sm" aria-hidden="true" />
                    ))}
                  </div>

                  {/* Review Text */}
                  <p className="text-gray-300 text-sm leading-relaxed italic">
                    "{review.text}"
                  </p>
                </div>

                <div className="pt-6 mt-6 border-t border-[#3f3f46] flex items-center justify-between text-xs">
                  <div>
                    <h3 className="text-white font-bold text-sm uppercase">{review.author}</h3>
                    <span className="text-gray-400">{review.location}</span>
                  </div>
                  <span className="text-[#d96b27] bg-[#18181b] px-2.5 py-1 rounded text-[11px] font-bold border border-[#3f3f46]">
                    {review.date}
                  </span>
                </div>
              </div>
            );
          })}
        </div>

        {/* Carousel indicators */}
        <div className="flex justify-center items-center gap-2 mt-8">
          {TESTIMONIALS.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrentIndex(i)}
              className={`h-2.5 rounded-full transition-all ${
                i === currentIndex ? "w-8 bg-[#d96b27]" : "w-2.5 bg-gray-700 hover:bg-gray-500"
              }`}
              aria-label={`Gå til anmeldelse ${i + 1}`}
            />
          ))}
        </div>

      </div>
    </section>
  );
}
